<button
  *ngFor="let preset of presets; let i = index"
  class="preset"
  (click)="setCurrentPreset(i)"
  [ngClass]="{ 'preset--active': i === currentPreset }"
  [disabled]="disablePresetButtons"
>
  {{ preset }}
</button>
